import {
    transition,
    trigger,
    query,
    style,
    animate,
    group,
    animateChild, state
} from '@angular/animations';

export const slideInAnimation =[
    trigger('routeAnimations', [
        // route 'enter and leave (<=>)' transition
        transition('*<=>*', [

            // css styles at start of transition
            style({filter: 'blur(8px)'}),

            // animation and styles at end of transition
            animate('200ms', style({filter: 'blur(0px)'}))
        ])
    ]),
    trigger('flyInOut',   [
        transition(
            ':enter',
            [
                style({filter: 'blur(8px)'}),
                animate('200ms ease-out',
                    style({filter: 'blur(0px)'}))
            ]
        ),
        transition(
            ':leave',
            [
                // style({filter: 'blur(0px)'}),
                // animate('0s ease-out',
                //     style({filter: 'blur(8px)'}))
            ]
        )
    ])
];





